import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getResidueTypeList,
	addNewResidueType,
	updateResidueType,
	deleteResidueType,
	getResidueType,
} from '../residueType/thunk';

export const initialState = {
	itemResidueTypeList: [],
	itemResidueTypeDetail: null,
	isResidueTypeLoading: false,
	isResidueTypeSuccess: false,

	residueTypeList: [],
	residueTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ResidueTypeSlice = createSlice({
	name: 'ResidueTypes',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getResidueType.fulfilled, (state, action) => {
			state.isResidueTypeLoading = false;
			state.isResidueTypeSuccess = true;
			state.itemResidueTypeDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getResidueType.pending, state => {
			state.isResidueTypeLoading = true;
			state.isResidueTypeSuccess = null;
			state.error = null;
            state.itemResidueTypeDetail = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueType.rejected, (state, action) => {
			state.isResidueTypeLoading = false;
			state.isResidueTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getResidueTypeList.pending, state => {
			state.isResidueTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueTypeList.fulfilled, (state, action) => {
			state.itemResidueTypeList = action.payload;
			state.residueTypeList = action.payload;
			state.isLoadingList = false;
			state.isResidueTypeSuccess = true;

			let residueTypeListSelect = [];
			action.payload.map(item =>
				residueTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.residueTypeListSelect = residueTypeListSelect;
		});
		builder.addCase(getResidueTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isResidueTypeSuccess = true;
		});
		builder.addCase(addNewResidueType.fulfilled, (state, action) => {
			state.itemResidueTypeList.push(action.payload);
			state.residueTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewResidueType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewResidueType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateResidueType.fulfilled, (state, action) => {
			state.itemResidueTypeList = state.itemResidueTypeList.map(residueType =>
				residueType.residueTypename === action.payload.old_residueType
					? { ...residueType, ...action.payload.updated_residueType }
					: residueType
			);
			state.residueTypeList = state.residueTypeList.map(residueType =>
				residueType._id.toString() === action.payload._id.toString()
					? { ...residueType, ...action.payload }
					: residueType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateResidueType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateResidueType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteResidueType.fulfilled, (state, action) => {
			state.itemResidueTypeList = current(state.itemResidueTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.residueTypeList = current(state.residueTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteResidueType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteResidueType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ResidueTypeSlice.actions;

export default ResidueTypeSlice.reducer;
